module.exports = __webpack_public_path__ + "static/unbabel-79e23a650a172304acebdb3c0041aee6.svg";